import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { KnBrOrderReturnEffects } from '../../feature-libs/kn-br-order/core/store/effects/kn-br-order-return.effects';
import { knBrOrderReturnReducer } from '../../feature-libs/kn-br-order/core/store/reducers/kn-br-order-return.reducer';
import { KN_BR_ORDER_RETURN_FEATURE } from './kn-br-order-return.state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(KN_BR_ORDER_RETURN_FEATURE, knBrOrderReturnReducer),
    EffectsModule.forFeature([KnBrOrderReturnEffects]),
  ],
})
export class KnBrOrderReturnStateModule {}
